import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-location',
  templateUrl: './location.component.svg',
})
export class LocationComponent extends MedrecordIcon {
  viewHeight = 16;
  viewWidth = 16;
}
